unit GetBarcode;

interface

uses System.SysUtils, System.Variants, System.Classes, Vcl.Graphics, Vcl.Controls,
     Vcl.Forms, Vcl.Dialogs, WebBasis2, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCCustomComponent,
     VCL.TMSFNCBitmapContainer, WEBLib.Controls, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics,
     VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, WEBLib.ExtCtrls, Vcl.StdCtrls, WEBLib.StdCtrls,
     WEBLib.Devices, Web, Js, WebBasis;

[async] function Get_Barcode(  var sBarcode : String ) : TModalResult; async;

type
  TfrmGetBarcode = class(TfrmWebBasis2)
    WebPanel1: TPanel;
    btnClose: TTMSFNCToolBarButton;
    WebBarcodeDecoder1: TBarcodeDecoder;
    WebCamera1: TCamera;
    WebButton1: TButton;
    WebButton2: TButton;
    WebEdit1: TEdit;
    procedure WebButton1Click(Sender: TObject);
    procedure WebQRDecoder1Decoded(Sender: TObject; ADecoded: string);
    procedure WebButton2Click(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);

  private
    sSelBarcode : String;
  public

  protected procedure LoadDFMValues; override; end;

var frmGetBarcode: TfrmGetBarcode;

implementation

{$R *.dfm}

//====================================================================================================================//

function Get_Barcode(  var sBarcode : String ) : TModalResult;
begin

  sBarcode := '';

  frmGetBarcode :=  TfrmGetBarcode.Create(Application);
  frmGetBarcode.Popup  := True;

  await( TfrmGetBarcode, frmGetBarcode.Load() );

  Try

    await( TModalResult, frmGetBarcode.Execute); // excute form and wait for close

    Result := frmGetBarcode.ModalResult;

    If Result = mrOK then
      Begin
       sBarcode := frmGetBarcode.sSelBarcode;
      End;

  Finally
    frmGetBarcode.Free;
  End;

end;

//====================================================================================================================//


procedure TfrmGetBarcode.btnCloseClick(Sender: TObject);
begin
  inherited;
  WebCamera1.Stop;

  ModalResult := mrOK;
  Close;

end;

procedure TfrmGetBarcode.WebButton1Click(Sender: TObject);
begin
  inherited;

    WebCamera1.Start ;

    WebBarcodeDecoder1.EnableTimer := True;



end;



procedure TfrmGetBarcode.WebButton2Click(Sender: TObject);
begin
  inherited;
    WebCamera1.Stop;
end;

//====================================================================================================================//

procedure TfrmGetBarcode.WebFormShow(Sender: TObject);
begin
  inherited;

  self.Left   := 0;
  self.Top    := 0;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight;
  Self.Resize;

  WebCamera1.Start;

end;

//====================================================================================================================//

procedure TfrmGetBarcode.WebQRDecoder1Decoded(Sender: TObject; ADecoded: string);
begin
  inherited;

  WebEdit1.Text := ADecoded;
  sSelBarcode := ADecoded;

  btnCloseClick( nil );


end;

//====================================================================================================================//

procedure TfrmGetBarcode.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  btnClose := TTMSFNCToolBarButton.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebCamera1 := TCamera.Create(Self);
  WebBarcodeDecoder1 := TBarcodeDecoder.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebCamera1.BeforeLoadDFMValues;
  WebBarcodeDecoder1.BeforeLoadDFMValues;
  try
    Width := 388;
    Caption := 'frmGetBarcode';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WaitMessage.Left := 339;
    WaitMessage.Top := 98;
    BitmapCont.Left := 135;
    BitmapCont.Top := 136;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 388;
    WebPanel1.Height := 57;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 2;
    WebPanel1.TabOrder := 2;
    btnClose.SetParentComponent(WebPanel1);
    btnClose.Name := 'btnClose';
    btnClose.Left := 7;
    btnClose.Top := 5;
    btnClose.Width := 88;
    btnClose.Height := 41;
    btnClose.Cursor := crHandPoint;
    btnClose.ParentDoubleBuffered := False;
    btnClose.DoubleBuffered := True;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWindowText;
    btnClose.Font.Height := -11;
    btnClose.Font.Name := 'Segoe UI';
    btnClose.Font.Style := [];
    btnClose.ParentColor := True;
    btnClose.TabOrder := 0;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnClose.Text := '';
    btnClose.Bitmaps.Clear;
    with btnClose.Bitmaps.Add do
    begin
      Bitmap.LoadFromFile('GetBarcode.btnClose.Bitmaps.Bitmap.png');
      BitmapName := 'LINKS';
    end;
    btnClose.BitmapVisible := True;
    btnClose.ControlIndex := 0;
    WebButton1.SetParentComponent(WebPanel1);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 101;
    WebButton1.Top := 3;
    WebButton1.Width := 57;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Start';
    WebButton1.ChildOrder := 1;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.Visible := False;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel1);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 164;
    WebButton2.Top := 3;
    WebButton2.Width := 57;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Stop';
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.Visible := False;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebEdit1.SetParentComponent(WebPanel1);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 102;
    WebEdit1.Top := 28;
    WebEdit1.Width := 155;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 3;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.Text := 'WebEdit1';
    WebEdit1.Visible := False;
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebCamera1.SetParentComponent(Self);
    WebCamera1.Name := 'WebCamera1';
    WebCamera1.Left := 0;
    WebCamera1.Top := 57;
    WebCamera1.Width := 388;
    WebCamera1.Height := 287;
    WebCamera1.Align := alClient;
    WebCamera1.CameraType := ctRear;
    WebBarcodeDecoder1.SetParentComponent(Self);
    WebBarcodeDecoder1.Name := 'WebBarcodeDecoder1';
    WebBarcodeDecoder1.Camera := WebCamera1;
    WebBarcodeDecoder1.EnableTimer := True;
    WebBarcodeDecoder1.Reader := [bcvCode128,bcvEAN,bcvEAN8,bcvCode39,bcvI2OF5,bcv2OF5,bcvCode93];
    SetEvent(WebBarcodeDecoder1, Self, 'OnDecoded', 'WebQRDecoder1Decoded');
    WebBarcodeDecoder1.Left := 96;
    WebBarcodeDecoder1.Top := 88;
  finally
    WaitMessage.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebCamera1.AfterLoadDFMValues;
    WebBarcodeDecoder1.AfterLoadDFMValues;
  end;
end;

end.
